import Language from 'types/LanguageEnum';

export const DEFAULT_LANGUAGE = Language.EN_US;

type LocaleDetails = {
  country: string;
  language: string;
};

const OVERRIDDEN_ISO_LOCALES: { [key in Language]?: string } = {
  [Language.NO]: 'nb-NO',
  [Language.SV]: 'sv-SE',
  [Language.UK]: 'uk-UA',
};

export const getLocaleDetails = (locale: Language): LocaleDetails => {
  const regexp = /^([a-z]{2})([_-]([a-z]+))?$/i;
  const matches = (OVERRIDDEN_ISO_LOCALES[locale] ?? locale)?.match(regexp);

  if (matches) {
    const country = matches[1];
    const language = matches[3];
    return {
      country: country.toLowerCase(),
      language: (language ?? country).toUpperCase(),
    };
  }
  return getLocaleDetails(DEFAULT_LANGUAGE);
};

/**
 * @example
 *    getISOLocale('en-US') // 'en-US'
 *    getISOLocale('fr', '-') // 'fr-FR'
 */
export const getLocaleUsage = (locale: Language) => {
  const { country, language } = getLocaleDetails(locale);
  return `${country}-${language}`;
};
